import { Form, InputProps } from 'antd'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import React, { useState } from 'react'
import { Button } from 'src/components/Button'
import { TextInput } from 'src/components/TextInput'
import { usePhone } from 'src/hooks/usePhone'
import { Admin } from 'src/store/APIs/admins/types'
import { useMeQuery } from 'src/store/APIs/misc'

import { ChangePassword } from '../../ChangePassword'
import { strings } from '../strings'
import styles from './addAdmin.module.scss'
import { yupSync } from './validations'

interface AddAdminProps {
  data?: Admin
}

export const AddAdmin: React.FC<AddAdminProps> = ({ data }) => {
  const form = useFormInstance()

  const { data: me } = useMeQuery()
  const itsMe = me?.user.id === data?.id

  const isEditing = !!data

  const [showChangePassword, setShowChangePassword] = useState(false)

  const { updatePhone } = usePhone(data?.phone_number, form, 'phone_number')

  const onChangePhone: InputProps['onChange'] = event => {
    updatePhone(event.target.value)
  }

  const onClickChangePasswordButton = () => setShowChangePassword(true)

  return (
    <div>
      <h3>{strings.profileInformation}</h3>
      <div className={styles.topSection}>
        <div className={styles.inputContainer}>
          <div className={styles.fullNameSection}>
            <Form.Item
              name="first_name"
              rules={[yupSync]}
              className={styles.nameSection}>
              <TextInput
                label={strings.firstNameLabel}
                required
                placeholder={strings.firstNameLabel}
              />
            </Form.Item>
            <Form.Item
              name="last_name"
              rules={[yupSync]}
              className={styles.nameSection}>
              <TextInput
                label={strings.lastNameLabel}
                required
                placeholder={strings.lastNameLabel}
              />
            </Form.Item>
          </div>
          <Form.Item
            name="phone_number"
            rules={[yupSync]}
            className={styles.leftHalfSection}>
            <TextInput
              label={strings.phoneNumberLabel}
              required
              placeholder={strings.phoneNumberLabel}
              maxLength={14}
              onChange={onChangePhone}
            />
          </Form.Item>
        </div>
      </div>
      {!itsMe && (
        <h3>
          {isEditing ? strings.editAccountTitle : strings.createAccountTitle}
        </h3>
      )}
      <Form.Item
        name="email"
        rules={[yupSync]}
        className={styles.leftHalfSection}>
        <TextInput
          label={strings.emailLabel}
          required
          placeholder={strings.emailLabel}
        />
      </Form.Item>
      {isEditing && itsMe && !showChangePassword && (
        <Button type="primary" onClick={onClickChangePasswordButton}>
          {strings.changePasswordTitle}
        </Button>
      )}
      {showChangePassword && itsMe && (
        <ChangePassword setShowChangePassword={setShowChangePassword} />
      )}
    </div>
  )
}
